import { useTranslation } from "react-i18next";
import styles from "./ui.module.scss";

export const Button = ({ type, onClick, className, text }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      className={!className ? styles.btn : className}
      type={type}
      aria-label={t(text)}
    >
      {t(text)}
    </button>
  );
};
